import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap"; // Correct imports for LedgerViewModal
import ModalCloseButton from "../ModalCloseButton";
import guLocale from "../../locales/gu";

const AdminLedgerViewModal = ({ show, handleClose, initialData }) => {
  const locale = guLocale.ledgerViewModal;
  const ledgerData = initialData || {};
  const handleModalClose = () => {
    handleClose();
  };
  const getPaymentMethodText = (method) => {
    switch (method) {
      case "cash":
        return locale.paymentMethodCash;
      case "online":
        return locale.paymentMethodOnline;
      case "cheque":
        return locale.paymentMethodCheque;
      default:
        return method;
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>{locale.modalTitle}</Modal.Title>
        <ModalCloseButton onClick={handleModalClose} />
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col md={6}>
            <div className="mb-0">
              <label className="form-label fw-bold">{locale.transactionDateLabel}</label>
              <div className="border p-2 bg-light">
                {ledgerData.transaction_date
                  ? new Date(ledgerData.transaction_date).toLocaleDateString('en-GB')
                  : ""}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-0">
              <label className="form-label fw-bold">{locale.headNameLabel}</label>
              <div className="border p-2 bg-light">
                {ledgerData.head_id?.head_name}
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <div className="mb-0">
              <label className="form-label fw-bold">{locale.descriptionLabel}</label>
              <div className="border p-2 bg-light">{ledgerData.details}</div>
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-0">
              <label className="form-label fw-bold">{locale.amountLabel}</label>
              <div className="border p-2 bg-light">₹{ledgerData.amount}</div>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={6}>
            <div className="mb-0">
              <label className="form-label fw-bold">આવક/જાવક</label>
              <div className="border p-2 bg-light">
                {getPaymentMethodText(ledgerData.payment_method)}
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="mb-0">
              <label className="form-label fw-bold">આવક/ચુકવણી પદ્ધતિ</label>
              <div className="border p-2 bg-light">
                {ledgerData.transaction_type === "IN" ? locale.transactionTypeIn : locale.transactionTypeOut }
              </div>
            </div>
          </Col>
        </Row>
        {ledgerData.cheque_number && ledgerData.cheque_number && (
          <Row className="mb-3">
            {ledgerData.cheque_number && (
              <Col md={6}>
                <div className="mb-0">
                  <label className="form-label fw-bold">
                  {locale.chequeVoucherNoLabel}
                  </label>
                  <div className="border p-2 bg-light">
                    {ledgerData.cheque_number}
                  </div>
                </div>
              </Col>
            )}
            {ledgerData.cheque_pfms_clearing_date && (
              <Col md={6}>
                <div className="mb-0">
                  <label className="form-label fw-bold">
                  {locale.chequeClearingDateLabel}
                  </label>
                  <div className="border p-2 bg-light">
                    {ledgerData.cheque_pfms_clearing_date}
                  </div>
                </div>
              </Col>
            )}
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleModalClose}>
        {locale.closeButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminLedgerViewModal;
